module.exports = __webpack_public_path__ + "img/叶坪红色中华通讯社旧址.30690e63.png";